<script lang="ts">
	import ScrollReveal from '$lib/components/ScrollReveal.svelte';
	import GlowCard from '$lib/components/GlowCard.svelte';
	import type { Service } from '$lib/data/services';

	interface Props {
		service: Service;
		delay?: number;
		iconColor?: string;
	}

	let { service, delay = 0, iconColor = 'text-ameta-green' }: Props = $props();
</script>

<ScrollReveal {delay}>
	<GlowCard class="h-full">
		<div class="p-8 h-full flex flex-col">
			<div
				class="w-14 h-14 rounded-xl bg-gradient-to-br {service.gradient} flex items-center justify-center {iconColor} mb-6"
			>
				{@html service.icon}
			</div>
			<h3 class="text-xl font-semibold mb-3 text-slate-100">{service.title}</h3>
			<p class="text-slate-400 leading-relaxed flex-grow">{service.description}</p>
		</div>
	</GlowCard>
</ScrollReveal>
